"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./hal-rest-client"));
__export(require("./hal-resource"));
__export(require("./hal-decorator"));
__export(require("./hal-factory"));
__export(require("./hal-json-serializer"));
__export(require("./hal-json-parser"));
__export(require("./uri"));
//# sourceMappingURL=index.js.map